module.exports = __webpack_public_path__ + "img/upload.56fc6283.svg";